import TtamTargetSummaryItem from './item/index.vue';
import TtamTargetSummaryContainer from './container/index.vue';
import { usePropsTargetSummaryData, usePropsVisible } from './hooks';

export default {
  TtamTargetSummaryItem,
  TtamTargetSummaryContainer,
  usePropsTargetSummaryData,
  usePropsVisible,
};
